import { Col } from "antd";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-top: -65px;
  padding: 0 2rem;

  .ant-card-head-title {
    font-size: 1.25rem;
    line-height: 1.25rem;
  }

  .width-limiter {
    width: 100%;
    max-width: 1600px;

    #course-landing-content {
      margin-bottom: 200px;
      .ant-row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }
    }
  }

  @media screen and (max-width: 800px) {
    padding: 0 1rem;

    .width-limiter {
      padding: 10px 5px;
    }
  }
`;

export const ColPlay = styled(Col)`
  z-index: 2;
  position: relative;
  bottom: 14rem;
  width: 100%;
  max-width: 37%;

  .sticky-container {
    width: 100%;
    top: 0;
  }

  @media screen and (min-width: 801px) {
    .sticky-container {
      position: -webkit-sticky;
      position: sticky;
      overflow-y: auto;
    }
  }

  @media screen and (max-width: 900px) {
    max-width: 40%;
  }

  @media screen and (max-width: 800px) {
    max-width: 100%;
    position: initial;
    padding: 0;
    bottom: 0;
  }
`;

export const ColContent = styled(Col)`
  width: 100%;
  max-width: 58%;

  @media screen and (max-width: 800px) {
    margin-top: 20px !important;
    max-width: 100%;
  }
`;
